export const formatCellAllowProps = ['bold', 'level', 'italic', 'list_tag'] as const
